module.exports = __webpack_public_path__ + "static/media/cognizant.4adb05dd.png";